export default __webpack_public_path__ + "static/media/404-page-light.c448d3fd.png";